








































import {Component, Vue} from "vue-property-decorator";
import myTitle from "./components/myTitle.vue";


@Component({
  components: {
    myTitle
  },
})

export default class SelfService extends Vue {
  path = 'assets/solution/selfService/';

  cardContent = [
    {src:this.path+'zijian.png',title:'自建团队成本高',text:'自助设备分布地区广，自建售后团队成本太高，周期长，很多企业难以负担'},
    {src:this.path+'jindu.png',title:'服务进度不明确',text:'服务状况难以跟进，服务商没有成熟的管理系统，不清楚售后服务是否按企业要求的标准进行，容易与客户产生争议，影响企业口碑'},
    {src:this.path+'xiaolv.png',title:'服务团队效率低',text:'外包团队接单慢，小团队人手不足，不能及时处理企业问题，影响客户使用体验'},
    {src:this.path+'zhiliang.png',title:'服务质量没保障',text:'服务质量参差不齐，难以保障，很多服务商没有自有团队，服务人员不够专业，可能影响企业声誉'},
    {src:this.path+'weihu.png',title:'维护历史难追溯',text:'设备维护的历史情况没有备案或者很难查询，管理方式不科学、不合理'},
    {src:this.path+'baoxiu.png',title:'报修渠道太单一',text:'传统电话报修效率低，很难全面了解企业提供的服务内容，客户体验差'},
  ];

  solutions = [
    {
      bgImg: this.path + 'bgImg1.png',
      index: this.path + 'first.png',
      title: '服务网络遍布全国', text: '全国有350+服务站点，拥有约2000人的自有专业服务团队，服务人员兢兢业业，服务质量值得信赖，服务范围覆盖全国'
    },
    {
      bgImg: this.path + 'bgImg2.png',
      index: this.path + 'second.png',
      title: '多渠道快速售后处理', text: '平台支持APP、微信、二维码、网页、电话等多种方式提交服务请求，系统统一处理工单，服务人员将第一时间接单，快速响应，及时处理'
    },
    {
      bgImg: this.path + 'bgImg3.png',
      index: this.path + 'third.png',
      title: '售后进度实时跟踪', text: '平台将实时更新工单情况，消息可通过短信、手机app、微信等多种方式通知用户，让您全程掌握售后信息，轻松进行售后管理'
    },
    {
      bgImg: this.path + 'bgImg4.png',
      index: this.path + 'fourth.png',
      title: '可视化设备状况', text: '所有设备售后记录都将由系统备案整理，可在设备管理中清晰了解每台设备状况，帮助用户做出科学保养计划'
    },
  ];
}


